enum Themes {
    SOMNIWORKS_THEME = "somniworks",
    NORDIC_BLUE_THEME = "NORDIC_BLUE_THEME",
    DARK_FAE_THEME = "DARK_FAE_THEME",
    DARK_FAIRY_THEME = "DARK_FAIRY_THEME",
    DARK_THEME = "DARK_THEME",
    DARK_THEME_NEW = "DARK_THEME_NEW",
    DARK_THEME_PURPLE = "DARK_THEME_PURPLE",
    // GREEN_OASIS_THEME = "GREEN_OASIS_THEME",
    GREEN_OASIS_THEME = "Green Oasis",
    FAE_RED_THEME = "FAE_RED_THEME",
    LIGHT_FAE_THEME = "LIGHT_FAE_THEME",
    LIGHT_THEME = "LIGHT_THEME",
    // PINK_THEME = "PINK_THEME",
    PINK_THEME = "Pink",
    LIGHT_BLUE_THEME = "LIGHT_BLUE_THEME",
}

export default Themes
